// Define model types
export const MODEL_TYPES = [
  {
    id: 'stewie_quant',
    name: 'StewieQuant Algorithm',
    description: 'Proprietary multi-factor algorithm with automatic optimization',
    category: 'proprietary'
  },
  {
    id: 'lstm',
    name: 'LSTM Neural Network',
    description: 'Long Short-Term Memory recurrent neural network for time series forecasting',
    category: 'ml'
  },
  {
    id: 'hdk',
    name: 'Higher Dimensional Kernel',
    description: 'Advanced kernel-based model for non-linear market pattern detection',
    category: 'ml'
  },
  {
    id: 'arima',
    name: 'ARIMA Model',
    description: 'AutoRegressive Integrated Moving Average for time series prediction',
    category: 'statistical'
  },
  {
    id: 'xgboost',
    name: 'XGBoost',
    description: 'Gradient boosting framework for classification and regression',
    category: 'ml'
  },
  {
    id: 'rl_dqn',
    name: 'Reinforcement Learning (DQN)',
    description: 'Deep Q-Network for adaptive trading strategies',
    category: 'ml'
  },
  {
    id: 'stewiegpt',
    name: 'StewieGPT',
    description: 'NLP-based sentiment analysis for news and market data',
    category: 'proprietary'
  },
  {
    id: 'ensemble',
    name: 'Ensemble Model',
    description: 'Combines multiple models for improved prediction accuracy',
    category: 'ml'
  }
];

// Define risk levels
export const RISK_LEVELS = [
  {
    id: 'low',
    name: 'Conservative',
    description: 'Lower returns, lower volatility',
    maxDrawdown: '10%',
    maxPositionSize: '3%'
  },
  {
    id: 'medium',
    name: 'Moderate',
    description: 'Balanced risk-reward profile',
    maxDrawdown: '20%',
    maxPositionSize: '5%'
  },
  {
    id: 'high',
    name: 'Aggressive',
    description: 'Higher potential returns with increased volatility',
    maxDrawdown: '30%',
    maxPositionSize: '8%'
  }
];
